var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-refresh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    clipPath: "url(#clip-refresh)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-lock",
    "data-name": "Icon feather-lock",
    transform: "translate(6.5 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M5.343,16.5h5.9a.843.843,0,0,1,.843.843V20.3a.843.843,0,0,1-.843.843h-5.9A.843.843,0,0,1,4.5,20.3V17.343A.843.843,0,0,1,5.343,16.5Z",
    transform: "translate(0 -9.705)",
    fill: "none",
    stroke: "#8bc500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M10.5,6.8V5.108a2.108,2.108,0,0,1,4.217,0V6.8",
    transform: "translate(-4.313 0)",
    fill: "none",
    stroke: "#8bc500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-refresh",
    "data-name": "Icon ionic-ios-refresh",
    d: "M22.916,15.066a.744.744,0,0,0-.744.679,8.1,8.1,0,1,1-8.285-8.729.2.2,0,0,1,.2.2v2.51a.8.8,0,0,0,1.228.674l4.8-3.359a.8.8,0,0,0,0-1.352l-4.8-3.314a.8.8,0,0,0-1.228.674V5.329a.2.2,0,0,1-.195.2A9.541,9.541,0,1,0,23.659,15.87a.742.742,0,0,0-.744-.8Z",
    transform: "translate(0.5 0.749)",
    fill: "#8bc500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.061b05cae81be2131e2f52e7f4dd864e.svg";
export { ForwardRef as ReactComponent };